import { find, get, minBy } from "lodash";
import moment from "moment";
import {
  CONTACT_POINT_SYSTEM,
  DOCUMENTS_TYPES,
  PROJECT_TYPES,
  SALE_MODES,
  SUBSCRIPTION_STATUSES,
} from "utils/constants";

const QUOTE_RECEPTION_ATTACHMENT_TYPES = [
  DOCUMENTS_TYPES.QUOTE,
  DOCUMENTS_TYPES.DUTY_OF_ADVICE_QUOTE,
];

/**
 * Prefers an explicit field when present, otherwise the earliest quote /
 * precontractual attachment date (remise des documents = ouverture du délai),
 * then falls back to the subscription creation date.
 */
export const getAcorisQuoteReceptionDate = (subscription, attachments = []) => {
  const explicitReceptionDate = get(
    subscription,
    "project.fields.receptionDevis",
  );
  if (explicitReceptionDate) {
    return explicitReceptionDate;
  }

  const quoteAttachments = (attachments || []).filter(
    ({ type, createdDate }) =>
      QUOTE_RECEPTION_ATTACHMENT_TYPES.includes(type) && createdDate,
  );
  const earliestQuote = minBy(quoteAttachments, "createdDate");
  if (earliestQuote?.createdDate) {
    return earliestQuote.createdDate;
  }

  return get(subscription, "createdDate");
};

export const hasAcorisAdherentMobilePhone = (subscription) => {
  const telecoms = get(subscription, "project.contact.telecoms", []);
  const phone = get(
    find(telecoms, { system: CONTACT_POINT_SYSTEM.PHONE }),
    "value",
    "",
  );
  return Boolean(String(phone).trim());
};

/**
 * Distant sale + cold lead: e-sign only after 24h from quote reception.
 */
export const isAcorisEsignCoolingOffActive = (
  subscription,
  attachments = [],
) => {
  const isDistantColdLead =
    get(subscription, "project.contract.saleMode") === SALE_MODES.DISTANT &&
    get(subscription, "project.projectType") === PROJECT_TYPES.COLD_LEAD;

  if (!isDistantColdLead) {
    return false;
  }

  const receptionDate = getAcorisQuoteReceptionDate(subscription, attachments);
  if (!receptionDate) {
    return true;
  }

  return moment().isBefore(moment(receptionDate).add(24, "hours"));
};

export const shouldGateEsignOnComplementaryInfo = (
  status,
  additionalInfoPercentage,
) => {
  if (
    status === SUBSCRIPTION_STATUSES.SIGNED ||
    status === SUBSCRIPTION_STATUSES.PENDING
  ) {
    return false;
  }
  return additionalInfoPercentage < 100;
};
